export const GET_CAMPAIGN_RESOURCES_REQUESTING =
  "resource/GET_CAMPAIGN_RESOURCES_REQUESTING";
export const GET_CAMPAIGN_RESOURCES_SUCCESS =
  "resource/GET_CAMPAIGN_RESOURCES_SUCCESS";
export const GET_CAMPAIGN_RESOURCES_ERROR =
  "resource/GET_CAMPAIGN_RESOURCES_ERROR";

export const VISIT_CAMPAIGN_RESOURCE_REQUESTING =
  "resource/VISIT_CAMPAIGN_RESOURCE_REQUESTING";

export const SEND_CAMPAIGN_RESOURCE_FEEDBACK_REQUESTING =
  "resource/SEND_CAMPAIGN_RESOURCE_FEEDBACK_REQUESTING";
export const SEND_CAMPAIGN_RESOURCE_FEEDBACK_ERROR =
  "resource/SEND_CAMPAIGN_RESOURCE_FEEDBACK_ERROR";
export const SEND_CAMPAIGN_RESOURCE_FEEDBACK_SUCCESS =
  "resource/SEND_CAMPAIGN_RESOURCE_FEEDBACK_SUCCESS";

export const SEND_CAMPAIGN_RESOURCE_SUCCESS_REQUESTING =
  "resource/SEND_CAMPAIGN_RESOURCE_SUCCESS_REQUESTING";
export const SEND_CAMPAIGN_RESOURCE_ERROR =
  "resource/SEND_CAMPAIGN_RESOURCE_ERROR";

export const SET_RESOURCE = "resource/SET_RESOURCE";
